const FILE_FIELDS = `
  fragment fileFields on S3Drive {
    _id
    club
    name
    type
    url
    size
    createdBy
    createdAt
  }
`;

const FILE_TICKET_FIELDS = `
  fragment fileTicketFields on FileTicket {
    _id
    ticketId
    ticketIdType
    fileId
  }
`;

export const GET_FILES = `
  ${FILE_FIELDS}
  query ($term: String, $clubId: String, $skip: Int, $limit: Int, $sortingDir: String, $sortingField: String, $teams: [String], $profiles: [String], $fileType: String, $fromDate: String, $toDate: String) {
    getFiles(term: $term, clubId: $clubId, skip: $skip, limit: $limit, sortingDir: $sortingDir, sortingField: $sortingField, teams: $teams, profiles: $profiles, fileType: $fileType, fromDate: $fromDate, toDate: $toDate) {
      ...fileFields
    }
  }
`;

export const UPLOAD_FILE = `
  mutation ($fileName: String!, $size: Int!, $club: String!, $team: String) {
  uploadFile(fileName: $fileName, size: $size, club: $club, team: $team)
  {
    fileId
    uploadData
    url
  }
}
`;

export const UPLOAD_CLUB_GDPR_FILE = `
  mutation ($fileName: String!, $size: Int!, $club: String!, $uploadType: String!) {
    uploadFile(fileName: $fileName, size: $size, club: $club, uploadType: $uploadType) {
      fileId
      uploadData
    }
  }
`;

export const COMPLETE_CLUB_GDPR_UPLOAD = `
  mutation ($fileId: String!) {
    completeClubGdprUpload(fileId: $fileId) { fileId url }
  }
`;

export const CANCEL_CLUB_GDPR_UPLOAD = `
  mutation ($fileId: String!) {
    cancelClubGdprUpload(fileId: $fileId)
  }
`;

export const DELETE_FILE = `
  mutation ($fileId: String!) {
    deleteFile(fileId: $fileId)
  }
`;

export const SHARE_FILE = `
  mutation ($fileId: String!, $ticketId: String!, $ticketIdType: String!) {
    shareFile(fileId: $fileId, ticketId: $ticketId, ticketIdType: $ticketIdType)
  }
`;

export const UNSHARE_FILE = `
  mutation ($fileId: String!, $ticketId: String, $ticketIdType: String!) {
    unshareFile(fileId: $fileId, ticketId: $ticketId, ticketIdType: $ticketIdType)
  }
`;

export const GET_SHARED_FILE_DETAILS = `
${FILE_TICKET_FIELDS}
  query ($fileId: String!) {
    getSharedFileDetails(fileId: $fileId) {
      ...fileTicketFields
    }
  }
`;
